import React from 'react'

const DashDispatchsAdd = () => {
  return (
    <div>DashDispatchsAdd</div>
  )
}

export default DashDispatchsAdd